<template>
  <v-container class="text-center fill-height">
    <v-row justify="center" align="center">
      <v-col cols="12" md="6" lg="4">
        <v-card class="pa-5" elevation="10" rounded="lg">
          <v-card-title class="text-h5 font-weight-bold text-center accent--text">
            {{ title }}
          </v-card-title>
          <v-card-subtitle class="text-center mb-4">
            {{ description }}
          </v-card-subtitle>

          <v-form v-model="valid">
            <v-card-text>
              <v-text-field v-model="email" label="Email" :rules="emailRules" @keyup.enter="handleSubmit" required dense
                outlined></v-text-field>
            </v-card-text>

            <v-card-actions class="mt-3">
              <v-spacer></v-spacer>
              <custom-button @click="handleSubmit" label="저장" :disabled="!valid" color="primary" size="lg" gradient
                block></custom-button>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <loading-spinner :loading="isLoading"></loading-spinner>
  </v-container>
</template>
<script>
  // import LoginCard from '@/components/cards/LoginCard.vue';
  import CustomButton from '@/components/common/buttons/CustomButton.vue';
  import { authApi } from '@/api/api';

  export default {
    components: {
      CustomButton,
      // LoginCard,
    },
    data() {
      return {
        title: "국제한국어응용언어학회",
        description: '회원가입 시 사용한 이메일을 기입하세요. \n\n 메일로 임시 비밀번호가 발송됩니다.',
        email: '',
      };
    },
    methods: {
      async handleSubmit() {
        const body = {
          email: this.email,
        }

        try {
          const response = await authApi.getTemporaryPassword(body);

          if (response && response.status === 200) {
            await this.notifyVue('top', 'center', '메일이 발송되었습니다.');
          }
        } catch (error) {
          if (error.response.status === 400 && error.response.data.code === "member_not_found") {
            this.notifyVue('top', 'center', "가입하지 않은 이메일입니다.");
          } else if (error.response.status === 400 && error.response.data.code === "sns_registered") {
            const message = error.response.data.message;
            this.notifyVue('top', 'center', `${message}로 가입한 계정입니다. 소셜 로그인 방식을 이용해주세요.`);
            this.$router.push({ path: '/login' });
          } else {
            this.notifyVue('top', 'center', '잘못된 요청입니다. 제출한 이메일을 확인해주세요.', "danger");
          }
        }
      },
      notifyVue(verticalAlign, horizontalAlign, alertMessage, alert_type) {
        this.$notify({
          timeout: 8000,
          message: alertMessage,
          icon: "priority_high",
          type: alert_type ? alert_type : "danger",
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
        });
      },
    },
    computed: {
      emailRules() {
        return [
          v => !!v || this.$t('valid.required_email'),
          v => /.+@.+\..+/.test(v) || this.$t('valid.invalid_email')
        ];
      },
    },
  }
</script>

<style lang="scss" scoped>
  $primary-color: #ff9800;
  $sub-font-color: #424242;

  .submit-button {
    color: $primary-color;
    width: 100%;
  }

  .submit-container {
    margin-top: 0px;
    width: 100%;
  }
</style>